<template>
    <div>
      <Head title="Tipos de cliente" />
      <h1 class="mb-8 text-3xl font-bold">Tipos de cliente</h1>
      <div class="flex items-center justify-between mb-6 max-w-3xl">
        <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
        <Link class="btn-sky" href="/settings/clients/types/create">
          <span>Crear</span>
          <span class="hidden md:inline">&nbsp;Tipo</span>
        </Link>
      </div>
      
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-2">Id</th>
            <th class="pb-4 pt-6 px-2">Código</th>
            <th class="pb-4 pt-6 px-2">Descripción</th>
            <th class="pb-4 pt-6 px-2">Última modificación</th>
          </tr>
  
          
          <tr v-for="type in clientsTypes.data" :key="type.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/settings/clients/types/${type.id}/edit`"> 
                {{type.id}}  
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/settings/clients/types/${type.id}/edit`"> 
                {{type.code}}  
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/settings/clients/types/${type.id}/edit`"> 
                {{type.description}}  
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/settings/clients/types/${type.id}/edit`"> 
                {{type.updated_at}} hrs.
              </Link>
            </td>
            
          </tr>
          <tr v-if="clientsTypes.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="14">No se encontraron registros de tipos de clientes.</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="clientsTypes.links" />
    </div>
  </template>
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Layout'
  import mapValues from 'lodash/mapValues'
  import throttle from 'lodash/throttle'
  import pickBy from 'lodash/pickBy'
  import SearchFilter from '@/Shared/SearchFilter'
  import Search from '@/Shared/Search'
  import Pagination from '@/Shared/Pagination'
    
  export default {
    components: {
      Head,
      Icon,
      Link,
      SearchFilter,
      Search,
      Pagination,
    },
    layout: Layout,
    props: {
        clientsTypes: Array,
        filters: Object,
    },
    remember: 'form',
    data() {
      return {
        form: {
          search: this.filters.search,
          code: this.filters.code,
        },
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/settings/clients/types', pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
  </script>